import React from "react"
import "./Footer.css"

function Footer() {
    return (
        <React.Fragment>
            <footer className="footer mt-auto text-white-50">
                <p>For contact <a href="https://www.linkedin.com/in/mehmet-mutlu-334890185/">LinkedIn</a>, by <a href="https://github.com/MhmtMutlu">Mehmet Mutlu</a>.</p>
            </footer>
        </React.Fragment>
    )
}

export default Footer